import NotificationsList from "shared/components/dashboardCommon/notificationsList";

const DesignerNotifications = () => {
  return <NotificationsList />;
};

export default DesignerNotifications;
